import { render } from "./SiteLogo.vue?vue&type=template&id=abb1e6aa&ts=true"
import script from "./SiteLogo.vue?vue&type=script&lang=ts"
export * from "./SiteLogo.vue?vue&type=script&lang=ts"

import "./SiteLogo.vue?vue&type=style&index=0&id=abb1e6aa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__